<div class="summary-container playwright-component-loading">
    <div class="value-box-container" *ngFor="let number of iterArray">
        <label class="value-box-title">Loading</label>
        <label class="value-box-value">Loading</label>
        <div class="value-box-border"></div>
    </div>
</div>
